// THIS IS FOR GETTING MEN DATA TO SEARCH RESULT
export const GET_MEN_CLOTHES_DATA_REQUEST = "GET_MEN_CLOTHES_DATA_REQUEST";
export const GET_MEN_CLOTHES_DATA_SUCCESS = "GET_MEN_CLOTHES_DATA_SUCCESS";
export const GET_MEN_CLOTHES_DATA_FAILURE = "GET_MEN_CLOTHES_DATA_FAILURE";

// THIS IS FOR GETTING WOMEN DATA TO SEARCH RESULT
export const GET_WOMEN_CLOTHES_DATA_REQUEST = "GET_WOMEN_CLOTHES_DATA_REQUEST";
export const GET_WOMEN_CLOTHES_DATA_SUCCESS = "GET_WOMEN_CLOTHES_DATA_SUCCESS";
export const GET_WOMEN_CLOTHES_DATA_FAILURE = "GET_WOMEN_CLOTHES_DATA_FAILURE";

// THIS IS FOR GETTING KIDS DATA TO SEARCH RESULT
export const GET_KIDS_CLOTHES_DATA_REQUEST = "GET_KIDS_CLOTHES_DATA_REQUEST";
export const GET_KIDS_CLOTHES_DATA_SUCCESS = "GET_KIDS_CLOTHES_DATA_SUCCESS";
export const GET_KIDS_CLOTHES_DATA_FAILURE = "GET_KIDS_CLOTHES_DATA_FAILURE";

//TSHIRT
export const GET_TSHIRT_REQUEST = "GET_TSHIRT_REQUEST";
export const GET_TSHIRT_SUCCESS = "GET_TSHIRT_SUCCESS";
export const GET_TSHIRT_FAILURE = "GET_TSHIRT_FAILURE";

//TRACKSUITE
export const GET_TRACKSUIT_REQUEST = "GET_TRACKSUIT_REQUEST";
export const GET_TRACKSUIT_SUCCESS = "GET_TRACKSUIT_SUCCESS";
export const GET_TRACKSUIT_FAILURE = "GET_TRACKSUIT_FAILURE";

//TROUSER
export const GET_TROUSER_REQUEST = "GET_TROUSER_REQUEST";
export const GET_TROUSER_SUCCESS = "GET_TROUSER_SUCCESS";
export const GET_TROUSER_FAILURE = "GET_TROUSER_FAILURE";

//SWEATSHIRT
export const GET_SWEATSHIRT_REQUEST = "GET_SWEATSHIRT_REQUEST";
export const GET_SWEATSHIRT_SUCCESS = "GET_SWEATSHIRT_SUCCESS";
export const GET_SWEATSHIRT_FAILURE = "GET_SWEATSHIRT_FAILURE";
